export const stackedBarChartDataDashboard =[{
    name: 'Individuals',
    data: [23, 0, 0, 2]
  }, {
    name: '1-5 persons',
    data: [41, 0, 20, 8,]
  }, {
    name: '>5 persons',
    data: [4, 1, 1, 1]
  }]